const AUTHORED_ASSET_IDLE_TIMEOUT_MS = 1_000;

let authoredAssetTaskTail: Promise<void> = Promise.resolve();

function waitForBackgroundOpportunity(): Promise<void> {
  if (typeof globalThis.requestIdleCallback === "function") {
    return new Promise<void>((resolve) => {
      globalThis.requestIdleCallback(
        () => resolve(),
        { timeout: AUTHORED_ASSET_IDLE_TIMEOUT_MS },
      );
    });
  }
  return new Promise<void>((resolve) => setTimeout(resolve, 0));
}

/**
 * Keep every authored GLB decode/compile in one idle-time lane. Collections
 * can discover assets independently without overlapping expensive browser
 * work on the gameplay frame.
 */
export function scheduleAuthoredAssetBackgroundTask<T>(
  task: () => Promise<T>,
): Promise<T> {
  const result = authoredAssetTaskTail.then(async () => {
    await waitForBackgroundOpportunity();
    return task();
  });
  authoredAssetTaskTail = result.then(
    () => undefined,
    () => undefined,
  );
  return result;
}
